const FacelessBizSearchResultItemSkeleton = () => {
  return (
    <div className="flex w-full flex-row items-center justify-between gap-2">
      <div className="flex flex-row items-center gap-2.5">
        <div className="size-[40px] animate-pulse rounded-full bg-gray-200" />
        <div className="flex flex-col gap-2">
          <div className="h-4 w-32 animate-pulse rounded bg-gray-200" />
          <div className="h-3 w-24 animate-pulse rounded bg-gray-200" />
        </div>
      </div>
      <div className="size-4 animate-pulse rounded bg-gray-200" />
    </div>
  )
}

export default FacelessBizSearchResultItemSkeleton
